import React from 'react';
import { motion } from 'framer-motion';

const SlideThankYou: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center px-8">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
      >
        <span className="relative inline-block mb-6">
          <span
            className="absolute inset-0 text-6xl md:text-7xl font-black text-[#06b6d4] blur-xl opacity-50"
            aria-hidden="true"
          >
            Thank You
          </span>
          <span className="relative text-6xl md:text-7xl font-black bg-gradient-to-r from-[#0ea5e9] to-[#06b6d4] bg-clip-text text-transparent">
            Thank You
          </span>
        </span>
      </motion.div>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="text-2xl text-[#94a3b8] mb-12 max-w-2xl"
      >
        Ready to transform learning outcomes at your school?
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.5 }}
        className="flex flex-col items-center gap-8"
      >
        <a
          href="/contact"
          className="px-10 py-5 rounded-xl text-xl font-semibold text-white transition-all hover:scale-105"
          style={{
            background: 'linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%)',
            boxShadow: '0 0 30px rgba(14, 165, 233, 0.4)',
          }}
        >
          Schedule Your Demo
        </a>

        <div className="flex items-center gap-8 text-xl text-[#64748b]">
          <span>lumen8.it</span>
          <span>•</span>
          <span>hello@lumen8.it</span>
        </div>
      </motion.div>
    </div>
  );
};

export default SlideThankYou;
